import _filter from 'lodash/filter';

function Ctrl($rootScope, $scope, $timeout, favoritesService, modalService, metaTagService, loggerService) {
  $scope.loading = true;

  $scope.venues = [];
  $scope.events = [];
  $scope.lists = [];

  metaTagService.set({
    title: 'Your Favorites | Tablelist',
    description: 'Browse your favorite venues and events.'
  });

  favoritesService.listFavorites()
    .then(function(response) {
      $scope.venues = _filter(response, function(favorite) {
        return favorite.type === 'VENUE';
      });

      $scope.events = _filter(response, function(favorite) {
        return favorite.type === 'EVENT';
      });

      $timeout(function() {
        $scope.loading = false;
      }, 300);

      $timeout(function() {
        $rootScope.$broadcast('eventsLoaded');
        $rootScope.$broadcast('venuesLoaded');
      });
    }).catch(function(err) {
      loggerService.error(err);
    });
}

Ctrl.$inject = [
  '$rootScope',
  '$scope',
  '$timeout',
  'favoritesService',
  'modalService',
  'metaTagService',
  'loggerService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/accountFavorites/accountFavoritesCtrl.js